import apiCall from './apiCall';

const getAllRefDataPrivileges = async (param: any) => {
    const query = `?search=${param.search || ''}&pageNumber=${param.pageNumber}&pageSize=${param.pageSize}`;
    const URL = `/RefDataPrivileges/GetAllRefDataPrivileges${query}`;
    return apiCall('get', URL);
};

const getRefDataPrivilegeById = async (id: string) => {
    const URL = `/RefDataPrivileges/GetRefDataPrivilegeById/${id}`;
    return apiCall('get', URL);
};

const postRefDataPrivilege = async (data: any) => {
    const URL = '/RefDataPrivileges/Create';
    return apiCall('post', URL, data);
};

const putRefDataPrivilege = async (data: any) => {
    const URL = '/RefDataPrivileges/Update';
    return apiCall('post', URL, data);
};

const deleteRefDataPrivilege = async (data: any) => {
    const URL = '/RefDataPrivileges/Delete';
    return apiCall('post', URL, data);
};

export {
    getAllRefDataPrivileges,
    getRefDataPrivilegeById,
    postRefDataPrivilege,
    putRefDataPrivilege,
    deleteRefDataPrivilege,
};
